import React from "react"

import Header from "../components/Header"
import Navigation from "../components/Navigation"
import Incident from "../components/incident/Incident"

function IncidentPage() {
  return (
    <>
      <Header />
      <div className="page-with-nav">
        <Navigation />
        <Incident />
      </div>
    </>
  )
}

export default IncidentPage
